import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    CardActions,
    TextField,
    InputLabel,
    InputAdornment,
    IconButton,
} from "@mui/material";
import GreyButton from "../components/GreyButton";
import { ReactComponent as SelfWealthLogo } from "../assets/Selfwealth New 2022.svg";
import PopUpModal from "../components/PopUpModal";
import MessageModal from "../components/MessageModal";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { URL, origin } from "../config";
import { Helmet } from "react-helmet-async";

export default function SelfWealth() {
    const [popUpOpen, setPopUpOpen] = React.useState(false);
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [pass, setPass] = React.useState("");
    const [error, setError] = React.useState("");
    const [showPass, setShowPass] = React.useState(false);
    const navigate = useNavigate();
    const theme = createTheme({
        secondary: "#EEEEEE",
    });

    const handleLink = (e) => {
        e.preventDefault();

        if (!email || !pass) {
            setError("email and username required");
        } else {
            setPopUpOpen(true);
            const data = {
                username: email,
                password: pass,
            };
            fetch(`${URL}/link/selfwealth`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "content-type": "application/json",
                    Origin: `${origin}`,
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                    if (response.ok === false) {
                        setError(response.statusText);
                        navigate(`/${response.status}`);
                        throw new Error(data.message);
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.error) {
                        setError(data.error.message);
                        throw new Error(data.error.message);
                    }
                    setPopUpOpen(false);
                    setSuccessOpen(true);
                })
                .catch((err) => {
                    console.log(err);
                    setPopUpOpen(false);
                });
        }
    };

    const handleShowPass = () => {
        setShowPass((show) => !show);
    };

    const closeMessage = () => {
        setSuccessOpen(false);
        setError("");
    };

    return (
        <>
            <Helmet>
                <title>Wealthwatch | Link SelfWealth</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <Card>
                    <CardContent
                        sx={{
                            background:
                                "linear-gradient(315deg, #84fb95 0%, #cef576 74%)",
                        }}
                    >
                        <Typography
                            color="black"
                            variant="h6"
                            sx={{
                                fontWeight: 200,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <SelfWealthLogo
                                style={{ height: "40px", width: "70px" }}
                            />
                            SelfWealth
                        </Typography>
                        <Box
                            color="black"
                            sx={{
                                fontWeight: 200,
                                py: 2,
                                fontSize: 15,
                                fontFamily: "sans-serif",
                            }}
                        >
                            Get information about your commbank netbank account.
                            Including total account value of each account,
                            account name and currency.
                            <br></br>
                            In order to get this information, we need your
                            Netbank ID and password. We use this information to
                            login as you to generate a session with the the
                            commbank servers. We then store this session
                            information and use automated API calls to get the
                            desired information.
                            <br></br>
                            <Typography variant="h6" sx={{ py: 1 }}>
                                What data can we exactly get?
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: "bold" }}
                            >
                                For each protfolio we can get:
                            </Typography>
                            - The name of the assoicated with the portfolio
                            <br></br>- Portfolio total value
                            <br></br>- The days earnings and the portfolio
                            percentage change for the day.
                            <br></br>
                            <Typography
                                variant="subtitle2"
                                sx={{ py: 1, fontWeight: "bold" }}
                            >
                                For the selfwealth account we can get:
                            </Typography>
                            - The name of the account
                            <br></br>- The available cash balance
                        </Box>
                    </CardContent>
                    <Box sx={{}}>
                        <InputLabel sx={{ mx: 1 }}>
                            Link your SelfWealth account
                        </InputLabel>
                        <CardActions sx={{ py: 1 }}>
                            <TextField
                                variant="outlined"
                                label="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                sx={{
                                    width: "30%",
                                    "@media (max-width: 75em)": {
                                        width: "50%",
                                    },
                                }}
                            >
                                email
                            </TextField>
                            <TextField
                                type={showPass ? "text" : "password"}
                                variant="outlined"
                                label="password"
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                                sx={{
                                    width: "30%",
                                    "@media (max-width: 75em)": {
                                        width: "50%",
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                onClick={handleShowPass}
                                            >
                                                {showPass ? (
                                                    <VisibilityOff />
                                                ) : (
                                                    <Visibility />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            >
                                Password
                            </TextField>
                        </CardActions>
                        <GreyButton
                            disabled={!(email.length && pass.length)}
                            onClick={handleLink}
                            sx={{ m: 1 }}
                        >
                            Submit
                        </GreyButton>
                    </Box>
                </Card>
                <PopUpModal open={popUpOpen} />
                <MessageModal
                    severity="error"
                    title="error"
                    open={error ? true : false}
                    onClose={closeMessage}
                >
                    {error}
                </MessageModal>
                <MessageModal
                    severity="success"
                    title="success"
                    open={successOpen}
                    onClose={closeMessage}
                >
                    Linked SelfWealth account
                </MessageModal>
            </ThemeProvider>
        </>
    );
}
